import { useCallback, useState } from 'react';
import { changelog } from '@/constants/changelog';

const SEEN_KEY = 'hazcheck:changelog:seen';

function readSeen(): Set<string> {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (raw) return new Set(JSON.parse(raw) as string[]);
  } catch {
    // storage unavailable
  }
  return new Set();
}

export function useChangelogUnseen() {
  const [seen, setSeen] = useState<Set<string>>(readSeen);
  const unseenCount = changelog.reduce((n, r) => (seen.has(r.version) ? n : n + 1), 0);

  const markAllSeen = useCallback(() => {
    const all = new Set(changelog.map((r) => r.version));
    try {
      localStorage.setItem(SEEN_KEY, JSON.stringify([...all]));
    } catch {
      // storage unavailable
    }
    setSeen(all);
  }, []);

  return { unseenCount, markAllSeen };
}
